import React from 'react';
import { Wrapper } from '../components';

class Typography extends React.Component{

    render(){
        return (
            <Wrapper>
                <h4 className="font-weight-light">Typography</h4>
                <div className="row">
                    <div className="col-sm-12 py-2">
                        <div className="card">
                            <div className="card-header">
                                <h5 className="mb-0">Normal text</h5>
                            </div>
                            <div className="card-body">
                                <p>Rapidy build custom themes for Bootstrap, the world's most popular front-end component library for mobile-first, responsive Web apps. This is a customizer and theme builder for Bootstrap. Choose from a huge collection of color palettes,
                                    fonts and SASS variables. Prototype different styles, and easily generate CSS from SASS to give your Bootstrap projects a unique look-and-feel.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 py-2">
                        <div className="card">
                            <div className="card-header">
                                <h5 className="mb-0">Lead text</h5>
                            </div>
                            <div className="card-body">
                                <p className="lead">This larger lead text that stands out a little more.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 py-2">
                        <div className="card">
                            <div className="card-header">
                                <h5 className="mb-0">Headings</h5>
                            </div>
                            <div className="card-body">
                                <h6>Heading 6</h6>
                                <h5>Heading 5</h5>
                                <h4>Heading 4</h4>
                                <h3>Heading 3</h3>
                                <h2>Heading 2</h2>
                                <h1 className="text-truncate">Heading 1</h1>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 py-2">
                        <div className="card">
                            <div className="card-header">
                                <h5 className="mb-0">Display</h5>
                            </div>
                            <div className="card-body">
                                <p className="display-4 text-truncate">Display 4</p>
                                <p className="display-3 text-truncate">Display 3</p>
                                <p className="display-2 text-truncate">Display 2</p>
                                <p className="display-1 text-truncate">Display 1</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 py-2">
                        <div className="card">
                            <div className="card-header">
                                <h5 className="mb-0">Text Utilities</h5>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-sm-4 py-2">
                                        <p className="lead">Marked text</p>
                                        <p>For highlighting a run of text due to its relevance in another context, use the 'mark' tag.</p>
                                        <mark>This is marked text</mark>
                                    </div>
            
                                    <div className="col-sm-4 py-2">
                                        <p className="lead">Deleted Text</p>
                                        <p>For indicating blocks of text that have been deleted use the 'del' tag.</p>
                                        <del>This is Deleted Text</del>
                                    </div>
            
                                    <div className="col-sm-4 py-2">
                                        <p className="lead">Strikethrough text</p>
                                        <p>For indicating blocks of text that are no longer relevant use the 's' tag.</p>
                                        <s>This is Deleted Text</s>
                                    </div>
            
                                    <div className="col-sm-4 py-2">
                                        <p className="lead">Inserted Text</p>
                                        <p>For indicating additions to the document use the 'ins' tag.</p>
                                        <ins>This is Inserted Text</ins>
                                    </div>
            
                                    <div className="col-sm-4 py-2">
                                        <p className="lead">Underlined Text</p>
                                        <p>To underline text use the 'u' tag.</p>
                                        <u>This is Underlined Text</u>
                                    </div>
            
                                    <div className="col-sm-4 py-2">
                                        <p className="lead">Small Text</p>
                                        <p>For de-emphasizing inline or blocks of text, use the 'small' tag.</p>
                                        <small>This is Small Text</small>
                                    </div>
            
                                    <div className="col-sm-4 py-2">
                                        <p className="lead">Bold Text</p>
                                        <p>For emphasizing a snippet of text with a heavier font-weight.</p>
                                        <strong>This is Bold Text</strong>
                                    </div>
            
                                    <div className="col-sm-4 py-2">
                                        <p className="lead">Emphasized Text</p>
                                        <p>For emphasizing a snippet of text with italics.</p>
                                        <em>This is Emphasized Text</em>
                                    </div>
                                    
                                    <div className="col-sm-4 py-2">
                                        <p className="lead">Code</p>
                                        <p>To show monospaced code.</p>
                                        <pre className="text-muted"><code>&lt;p&gt;this is HTML code...&lt;/p&gt;</code></pre>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 py-2">
                        <div className="card">
                            <div className="card-header">
                                <h5 className="mb-0">Blockquote</h5>
                            </div>
                            <div className="card-body">
                                <blockquote className="blockquote">
                                    <p className="mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.</p>
                                    <footer className="blockquote-footer">Someone famous in <cite title="Source Title">Source Title</cite></footer>
                                </blockquote>
                            </div>
                        </div>
                    </div>
                </div>
            </Wrapper>
        );
    }
}

export default Typography;
